import React, { Component } from 'react';
import moment from 'moment';
import UserHelper from '../../../../helper/user.js'
import PermissionProperties from '../../../../config/permission.js'

export default class Row extends Component{

  // ===  error === Useless constructor  no-useless-constructor

  // constructor(props){
  //   super(props)
  // }

  __RenderActionButton__(){
    var jsx = []
    if(UserHelper.HasPermission(PermissionProperties.USER.USER.UPDATE,this.props.self.props.UserReducer)){
      jsx.push(
          <td className="text-center" key={0}><button type="button" className="btn btn-4r btn-sm btn-primary" onClick={()=> this.props.self.__EditButtonClicked__(this.props.self,this.props.Data)}><i className="icon-pencil"></i></button></td>
      )
    }
    if(UserHelper.HasPermission(PermissionProperties.USER.USER.DELETE,this.props.self.props.UserReducer)){
      jsx.push(
          // hide delete
          //<td className="text-center"><button type="button" className="btn btn-4r btn-sm btn-danger" onClick={()=> this.props.self.__EditDeleteClicked__(this.props.self,this.props.Data)}><i className="icon-trash"></i></button></td>
      )
    }
    return jsx
  }
  render(){
    let labelStatus = null;
    if(this.props.Data.Active === true) {
      labelStatus = <span className="badge badge-success">Active</span>
    } else {
      labelStatus = <span className="badge badge-danger">Disabled</span>
    }

    return(
      <tr style={{whiteSpace:'nowrap'}} key={this.props.Data.Alias} role="button" onClick={()=> this.props.self.__EditButtonClicked__(this.props.self,this.props.Data)}>
        {/*<td>{this.props.Data.Alias}</td>*/}
        <td>{this.props.Data.Username}</td>
        <td>{this.props.Data.FirstName}</td>
        <td>{this.props.Data.LastName}</td>
        <td>{this.props.Data.Phone === null ? '-' : this.props.Data.Phone}</td>
{/*        <td>{this.props.Data.Address}</td>
        <td>{this.props.Data.Address2}</td>*/}
        <td>{this.props.Data.City}</td>
        {/*<td>{this.props.Data.Postal}</td>*/}

        {/*<td>{this.props.Data.Tag}</td>*/}
        <td className="text-center">{this.props.Data.Role}</td>
        <td className="text-center">{moment(this.props.Data.CreatedTime).format('YYYY-MM-DD')}</td>
        <td className="text-center">{labelStatus}</td>

{/*        <td>{this.props.Data.CreatedBy}</td>
        <td>{this.props.Data.ModifiedBy}</td>
        {/*<td>{this.props.Data.ModifiedTime === null ? '-':moment(this.props.Data.ModifiedTime).format('YYYY-MM-DD')}</td>*/}
        {/*<td><button type="button" className="btn btn-info" onClick={()=> this.props.self.__OnDetailClicked__(this.props.self,this.props.Data)}>Details</button></td>
        <td><button type="button" className="btn btn-primary" onClick={()=> this.props.self.__EditButtonClicked__(this.props.self,this.props.Data)}><i className="icon-pencil"></i>&nbsp; Edit</button></td>
        <td><button type="button" className="btn btn-danger" onClick={()=> this.props.self.__EditDeleteClicked__(this.props.self,this.props.Data)}><i className="icon-trash"></i>&nbsp; Delete</button></td>*/}
        {this.__RenderActionButton__()}
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/user/model/helper/children/row.js